<script lang="ts" setup>
const { t } = useI18n();
const localePath = useLocalePath();
const router = useRouter();

const contactDialogControls = useContactDialogControls();
const { load: loadContactDialog } = useContactDialogLazyLoad();

const { width } = useWindowSize();

const isMobile = computed(() => {
  return width.value < 400;
});

const onContactButtonClick = ref(() => {
  if (isMobile.value) {
    window?.scrollTo({ top: 0 });
    router.push(localePath("/contact"));
  } else {
    contactDialogControls.show();
  }
});
</script>

<template>
  <PageButton @mouseover="loadContactDialog()" @click="onContactButtonClick">
    {{ t("contactButton") }}
  </PageButton>
</template>

<style lang="scss" scoped>
.p-dialog-titlebar-icon {
  width: 100px;
}
</style>
